export enum HomeTabs {
  FOCUS = "focus",
  PERFORMANCE = "performance"
}
